<template>
    <div class="page-wrap d-flex flex-row align-items-center">
        <div class="container m-auto">
            <div class="row justify-content-center">
                <div class="col-md-12 text-center">
                    <span class="display-1 d-block">404</span>
                    <div class="mb-4 lead">La page que vous recherchez n'a pas été trouvée.</div>
                    <a href="/" class="btn btn-link">Retourner</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
name:'NoAccess',
components:{

},
data(){
  return{
  }
},
methods:{
  
},
  created(){
      
  }
}
</script>

<style scoped>
.page-not-found {
height: 60vh;
}
.page-not-found h2 {
font-size: 100px;
color: #e91e63;
}
.page-not-found h3 {
font-size: 35px;
}
.page-not-found .bg-light {
width: 50%;
padding: 50px;
text-align: center;
border-radius: 5px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}

@media (max-width:  767px) {
.page-not-found h2 {
    font-size: 90px;
}
.page-not-found h3 {
    font-size: 20px;
}
.page-not-found .bg-light {
    width: 100%;
}
}
</style>